import {
    UploadFileResponse
  } from "@/central-atoms/everest-fleet-pwa/responses";
import { API_BASE_URL } from "@/constants";
import axios, { AxiosResponse } from "axios";
  
class MiscellaneousService {
    static async uploadFile(
        payload: any,
        accessToken: string | null
    ): Promise<AxiosResponse<UploadFileResponse>> {
        return axios.post(
        `${API_BASE_URL}/upload_file`,
        payload,
        {
            headers: {
            Authorization: 'Bearer ' + accessToken
            }
        }
        );
    }

}

export default MiscellaneousService;
